/*
  IMPORTANT: this file cannot reference any modules that are related to react & redux
  this is because service-worker runs under a different scope and cannot use those modules
*/

import { CERTA_API_URL } from 'config';
import { get, post, put, putWithResponse } from './fetch';
import * as tokenService from 'services/token-service';

import { Tenant } from 'types/tenants/tenant';
import { Guid } from 'types/guid';
import { NmvsProviderCredentials } from 'types/tenants/nmvs-provider-credentials';
import { UpdateTenantResponse } from 'types/api/tenants/update-tenant-response';
import { RegisterDeviceResponse } from 'types/api/tenants/register-device-response';
import { GetTenantResponse } from 'types/api/tenants/get-tenant-response';

export async function registerDevice(tenantId: Guid, deviceId: Guid): Promise<Tenant> {
  const result = await get<RegisterDeviceResponse>(
    `${CERTA_API_URL}/tenants/${tenantId}/devices/${deviceId}`, undefined, tenantId);
  return result.tenant;
}

export async function unregisterDevice(tenantId: Guid, deviceId: Guid, username: string): Promise<void> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  await put(
    `${CERTA_API_URL}/tenants/${tenantId}/devices/${deviceId}/unregister?username=${username}`, {}, token, tenantId);
}

export async function getTenant(tenantId: Guid): Promise<Tenant> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const result = await get<GetTenantResponse>(CERTA_API_URL + '/tenants/' + tenantId, token, tenantId);
  return result.tenant;
}

export async function updatePreferences(
  tenantId: Guid, language: string): Promise<Tenant> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const request = {
    tenantId,
    language
  };
  const response = await putWithResponse<UpdateTenantResponse>(
    `${CERTA_API_URL}/tenants/${tenantId}/preferences`, request, token, tenantId);
  return response.tenant;
}

export async function updateNmvsProviderCredentials(
  tenantId: Guid, nmvsProviderCredentials: NmvsProviderCredentials): Promise<Tenant> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const request = {
    tenantId,
    nmvsProviderCredentials
  };
  var response = await putWithResponse<UpdateTenantResponse>(
    `${CERTA_API_URL}/tenants/${tenantId}/nmvsProviderCredentials`, request, token, tenantId);
  return response.tenant;
}

export async function addCustomSetting(tenantId: Guid, key: string, value: string): Promise<void> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const request = {
    key,
    value
  };
  await post(`${CERTA_API_URL}/tenants/${tenantId}/customSettings`, request, token, tenantId);
}

export async function updateCustomSetting(tenantId: Guid, key: string, value: string): Promise<void> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const request = {
    key,
    value
  };
  await put(`${CERTA_API_URL}/tenants/${tenantId}/customSettings/${key}`, request, token, tenantId);
}



// WEBPACK FOOTER //
// ./src/api/tenant-api.ts